export enum Experiments {
  FULL_DEAL_CONTEXT_ENTRY_BLOCK = '8a2b442a-f52a-4e9c',
  EXCLUDE_FULLDEAL_OFFERS = 'c81f3def-aee4-44fb',
  POPANDER_OPEN_OFFER = '6703ca81-fd01-4c7f',
}

export type AbTestingExperiments = Partial<Record<Experiments, boolean>>;

export const A_TEST_VALUE = '0';
export const B_TEST_VALUE = '1';
export const C_TEST_VALUE = '2';
export const D_TEST_VALUE = '3';
